import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
    cdGates: ['gates'],
		cdCleanGates: [''],
		cdCleanGateModal: [''],
		setNomeGate: [''],
		setCapacidadeDinamica: [''],
		setIdCdGate: [''],
		setCdGateModal: [''],
		setCdGateError:[''],
		setCdGateSuccess:[''],
		setCdGateValidCapacidadeForm:[''],
		setCdGateValidIntervaloForm:['']
});

//Reducer Handlers
const INITIAL_STATE = {
	cdGates:[],
	cdGateModal: {
		idCd: 0,
		capacidadeDinamica: false,
		nome: '',
		horarios: [
			{id: null, idDiaSemana: 1, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 2, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 3, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 4, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 5, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 6, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 },
			{id: null, idDiaSemana: 7, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade:0, carga: 1 }
		]
	},
	cdGateError: [],
	cdGateSuccess: [],
	cdGateValidForm: true,
	cdGateValidCapacidadeForm : true,
	cdGateValidIntervaloForm : true
}

const cdGates = (state = INITIAL_STATE, action) => {
	return { ...state, cdGates: action.payload }
}

const clean = (state = INITIAL_STATE, action) => {
	return { ...state, cdGates: INITIAL_STATE.cdGates	}
}

const cdCleanGateModal = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateModal: action.payload
	}
}

const setCdGateModal = (state = INITIAL_STATE, action) => {
	return {
		...state, 
		cdGateModal: action.payload
	}
}	

const setIdCdGate = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateModal: { 
			...state.cdGateModal, 
			idCd: action.payload.idCd
		}
	}
}		
		
const setNomeGate = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateModal: { 
			...state.cdGateModal, 
			nome: action.payload.nome,
		}	
	}
}

const setCapacidadeDinamica = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateModal: { 
			...state.cdGateModal, 
			capacidadeDinamica: action.payload.capacidadeDinamica,
		}	
	}
}

const setCdGateError = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateError: {
			...action.payload 
		}
	}
}	

const setCdGateSuccess = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateSuccess: {
			...action.payload
		}
	}
}	

const setCdGateValidCapacidadeForm = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateValidCapacidadeForm: action.valid,
	}
}

const setCdGateValidIntervaloForm = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		cdGateValidIntervaloForm: action.valid
	}
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.CD_GATES]: cdGates,
	[Types.CD_CLEAN_GATES]: clean,
	[Types.CD_CLEAN_GATE_MODAL]: cdCleanGateModal,
	[Types.SET_NOME_GATE]: setNomeGate,
	[Types.SET_CAPACIDADE_DINAMICA]: setCapacidadeDinamica,
	[Types.SET_ID_CD_GATE]: setIdCdGate,
	[Types.SET_CD_GATE_MODAL]: setCdGateModal,
	[Types.SET_CD_GATE_ERROR]: setCdGateError,
	[Types.SET_CD_GATE_SUCCESS]: setCdGateSuccess,
	[Types.SET_CD_GATE_VALID_CAPACIDADE_FORM]: setCdGateValidCapacidadeForm,
	[Types.SET_CD_GATE_VALID_INTERVALO_FORM]: setCdGateValidIntervaloForm
});
